import { useEffect, useState } from "react";
import Account, { AccountProps } from "./Account";
import BalanceSheet, { BalanceSheetProps } from "./BalanceSheet";
import CashFlowStatement, { CashFlowStatementProps } from "./CashFlowStatement";
import IncomeStatement, { IncomeStatementProps } from "./IncomeStatement";
import Ratio, { RatioProps } from "./Ratios";

interface StatementRenderedProps {
  rawData: UserData;
};

export interface UserData {
  id: number | null
  name: string | null
  email: string | null
  token: string | null
  phoneNumber: string | null
  balanceSheet: BalanceSheetProps
  incomeStatement: IncomeStatementProps
  cashFlowStatement: CashFlowStatementProps
  ratios: RatioProps
  accounts: AccountProps
};

const StatementRenderer: React.FC<StatementRenderedProps> = ({ rawData }) => {
  const [jsonData, setJsonData] = useState<UserData>();
  const [selectedTab, setSelectedTab] = useState<string>('balanceSheet');

  const isJsonString = (str: string): boolean => {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };

  const parseJsonData = (data: any): any => {
    if (typeof data === 'string' && isJsonString(data)) {
      return JSON.parse(data);
    } else if (Array.isArray(data)) {
      return data.map(item => parseJsonData(item));
    } else if (typeof data === 'object' && data !== null) {
      return Object.fromEntries(
        Object.entries(data).map(([key, value]) => [key, parseJsonData(value)])
      );
    }
    return data;
  };

  useEffect(() => {
    const data: UserData = parseJsonData(rawData);
    setJsonData(data);
  }, []);

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
  };

  return (
    <>
      {(jsonData && (
        Object.keys(jsonData.balanceSheet || {}).length > 0 ||
        Object.keys(jsonData.incomeStatement || {}).length > 0 ||
        Object.keys(jsonData.cashFlowStatement || {}).length > 0 ||
        Object.keys(jsonData.ratios || {}).length > 0
      )) && (
        <div>
          <div className="tabs">
            {(jsonData.balanceSheet && Object.keys(jsonData.balanceSheet).length > 0) &&
              <button
                className={`tab ${selectedTab === 'balanceSheet' ? 'active' : ''}`}
                onClick={() => handleTabChange('balanceSheet')}
              >
                Balance Sheet
              </button>
            }
            {(jsonData.incomeStatement && Object.keys(jsonData.incomeStatement).length > 0) &&
              <button
                className={`tab ${selectedTab === 'incomeStatement' ? 'active' : ''}`}
                onClick={() => handleTabChange('incomeStatement')}
              >
                Income Statement
              </button>
            }
            {(jsonData.cashFlowStatement && Object.keys(jsonData.cashFlowStatement).length > 0) &&
              <button
                className={`tab ${selectedTab === 'cashFlowStatement' ? 'active' : ''}`}
                onClick={() => handleTabChange('cashFlowStatement')}
              >
                Cash Flow Statement
              </button>
            }
            {(jsonData.ratios && Object.keys(jsonData.ratios).length > 0) &&
              <button
                className={`tab ${selectedTab === 'ratios' ? 'active' : ''}`}
                onClick={() => handleTabChange('ratios')}
              >
                Financial Ratios
              </button>
            }
          </div>

          <div className="tab-content">
            {selectedTab === 'balanceSheet' && jsonData.balanceSheet && (
              <BalanceSheet balanceSheet={jsonData.balanceSheet} />
            )}
            {selectedTab === 'incomeStatement' && jsonData.incomeStatement && (
              <IncomeStatement incomeStatement={jsonData.incomeStatement} />
            )}
            {selectedTab === 'cashFlowStatement' && jsonData.cashFlowStatement && (
              <CashFlowStatement cashFlowStatement={jsonData.cashFlowStatement} />
            )}
            {/* {selectedTab === 'ratios' && jsonData.ratios && (
              <Ratio ratios={jsonData.ratios} />
            )} */}
          </div>
        </div>
      )}
    </>
  );
};

export default StatementRenderer;